import { AdalConfig } from 'react-adal';

export const adalConfig: AdalConfig = {
    clientId: process.env.REACT_APP_AAD_CLIENT_ID!,
    redirectUri: process.env.REACT_APP_AAD_REDIRECT_URI,
    tenant: process.env.REACT_APP_AAD_TENANT,
    postLogoutRedirectUri: process.env.REACT_APP_AAD_REDIRECT_URI
};
